import type { ReactElement, ReactNode } from "react";

import { Tooltip, TooltipPopup, TooltipTrigger } from "./tooltip";

/** The app's tooltip on one element, in place of a native `title`. `\n` in a string label breaks the line. */
export function Tip({
  label,
  side,
  children,
}: {
  readonly label: ReactNode;
  readonly side?: "top" | "bottom" | "left" | "right";
  readonly children: ReactElement;
}) {
  if (label === undefined || label === null || label === "") return children;
  return (
    <Tooltip>
      <TooltipTrigger render={children} />
      <TooltipPopup side={side} className="max-w-72 whitespace-pre-line text-pretty">
        {label}
      </TooltipPopup>
    </Tooltip>
  );
}
